import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/card';
import type { Estate } from '@/features/estates-property/api/estate';

import type { EstateAnalysis } from '../api/analytics';

export const PricingHeatMap = ({
  estateAnalysis,
}: {
  data: Estate;
  estateAnalysis: EstateAnalysis;
}) => {
  const { t } = useTranslation();

  const data = useMemo(() => estateAnalysis.iframe, [estateAnalysis]);

  return (
    <div>
      <h2 className="mb-6 text-md font-bold text-primary-dark">{t('pricingHeatMap')}</h2>
      {data?.url ? (
        <Card className="p-0">
          <iframe
            width="100%"
            height="1068px"
            id="iframe"
            src={data.url}
            title={t('pricingHeatMap')}
          />
        </Card>
      ) : (
        <Card className="p-6 text-center text-sm text-text-secondary">
          <p>{t('pricingHeatMapNotAvailable')}</p>
        </Card>
      )}
    </div>
  );
};
